import axios, { AxiosResponse } from "axios"
import Axios from "./Axios"

class HTTPService {
    get(url: string, headers?: object) {
        if (url.startsWith("/address-api")) {
            // For address API, construct full URL to avoid baseURL conflicts
            const addressApiBaseUrl = process.env.REACT_APP_ADDRESS_API_BASE_URL || process.env.REACT_APP_BASE_API_URL + '/address-api';
            // Remove /address-api prefix and build full URL
            const path = url.replace("/address-api", "");
            const fullUrl = addressApiBaseUrl + path;
            // Use Axios instance with full URL to keep interceptors
            return Axios.get(fullUrl, headers);
        }else {
            return Axios.get(url, headers)
        }
    }

    post(url: string, urlData: object, headers?: object) {
        return Axios.post(url, urlData, headers)
    }

    put(url: string, urlData: object, headers?: object) {
        return Axios.put(url, urlData, headers)
    }

    delete(url: string, urlData?: object, headers?: object) {
        return Axios.delete(url, headers)
    }

    patch(url: string, urlData: object, headers?: object) {
        return Axios.patch(url, urlData, headers)
    }

    async all(promises: Promise<AxiosResponse<any, any>>[]) {
        return axios.all(promises)
    }
}

export default new HTTPService()
